import React, { Component } from 'react';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp} from "react-icons/fi";
import Footer from "../component/footer/Footer";



const onPress = (e) => {
    e.preventDefault();
    const target = window.document.getElementById(
        e.currentTarget.href.split("#")[1]
    );
    if (target) {
        target.scrollIntoView({ behavior: "smooth" });
    }
};


 class error404 extends Component {
    
    render() {
        return (
            <>
               <header className="header-area formobile-menu header--fixed default-color">
                    <div className="header-wrapper" id="header-wrapper">
                        <div className="header-left">
                            <div className="logo">
                                <a onClick={(e) => onPress(e)} href="/">
                                    <div data-to-scrollspy-id="home" className={"ss-item"}></div>
                                    <img className="logo-1" src="/assets/images/logo/logo-light.png" alt="Logo Images" />
                                    <img className="logo-2" src="/assets/images/logo/logo-all-dark.png" alt="Logo Images" />
                                </a>
                            </div>
                        </div>
                    </div>
                </header>
                {/* Start Page Error  */}
                <div className="error-page-inner bg_color--4">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner">
                                    <h1 className="title theme-gradient">Obrigado!</h1>
                                    <h3 className="sub-title">Contato enviado com sucesso</h3>
                                    <span>Nosso time entrará em contato o mais rápido possível.</span>
                                    <div className="error-button">
                                        <a className="btn-default" href="/">Recarregar página</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Error  */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer /> 
            </>
        )
    }
}
export default error404;
